import { DataGrid, GridValidRowModel } from "@mui/x-data-grid";
import { EIconNames } from "src/shared/types/iconNames";
import { IconComponent } from "../..";
import { ITableComponentProps } from "../model/types";
import PaginationComponent from "./PaginationComponent";

export function TableComponent<
  T extends Omit<GridValidRowModel, "pageSizeOptions">,
>({ hideHeader, loading, ...props }: ITableComponentProps) {
  return (
    <DataGrid<T>
      {...props}
      loading={loading}
      slots={{
        pagination: PaginationComponent,
        ...(hideHeader ? { columnHeaders: () => null } : {}),
        columnSortedAscendingIcon: () => (
          <IconComponent iconname={EIconNames.SORT_ASC} />
        ),
        columnSortedDescendingIcon: () => (
          <IconComponent iconname={EIconNames.SORT_DESC} />
        ),
        columnUnsortedIcon: () => (
          <IconComponent iconname={EIconNames.SORT_UNSORTED} />
        ),
        ...props.slots,
      }}
      slotProps={{
        ...props.slotProps,
        pagination: {
          total: props.rowCount,
          hidePagination: props.hidePagination,
          "aria-disabled": loading,
          pageSizeOptions: props.pageSizeOptions,
          paginationModel: props.paginationModel,
        },
      }}
      disableColumnFilter
      sx={{ border: "none" }}
    />
  );
}
